<template>
    <iframe id="bff-silent-login" :src="loginSrc" title="silent login" hidden></iframe>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useUserStore } from '.';

const loginSrc = ref<string>();

onMounted(() => {
    const store = useUserStore();

    if (store.isLoggedIn) return;

    loginSrc.value = '/bff/silent-login';

    window.addEventListener('message', e => {
        if (e.data && e.data.source === 'bff-silent-login' && e.data.isLoggedIn) {
            // we now have a user logged in silently, so reload this window
            window.location.reload();
        }
    });
});
</script>
